var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { RoleService } from "~/services/management-service/role.service";
import { CommonService } from "~/utils/common.service";
import { Emit, Watch, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";
import ResourceTree from "./resource-tree.vue";
import ResourceControl from "./resource-control.vue";
import CommonTitle from "~/components/common/common-title.vue";
var systemModule = namespace('system-manage');
var ModulePermission = /** @class */ (function (_super) {
    __extends(ModulePermission, _super);
    function ModulePermission() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.checkedMenuIds = [];
        _this.controlCheckedIds = [];
        _this.controlDataSet = [];
        _this.currentTreeKey = "";
        _this.treeData = [];
        return _this;
    }
    ModulePermission.prototype.refreshList = function () { };
    ModulePermission.prototype.onRoleIdChange = function (val) {
        if (!val)
            return;
        this.refreshDate();
    };
    ModulePermission.prototype.onCheckedMenuIdsChange = function (values, oldVlaues) {
        var _this = this;
        var oldCheckedControls = __spreadArrays(this.controlCheckedIds);
        // 处理增加的
        var addKeys = values.filter(function (x) { return !oldVlaues.includes(x); });
        addKeys.forEach(function (v) {
            var addControls = _this.systemControls.filter(function (x) { return x.parent === v; }).map(function (v) { return v.id; });
            oldCheckedControls.push.apply(oldCheckedControls, addControls);
        });
        var checkedControlSet = new Set(oldCheckedControls);
        // 处理减少的
        var unCheckMenuIds = oldVlaues.filter(function (x) { return !values.includes(x); });
        unCheckMenuIds.forEach(function (v) {
            var removeControls = _this.systemControls.filter(function (x) { return x.parent === v; });
            removeControls.forEach(function (c) { return checkedControlSet.delete(c.id); });
        });
        this.controlCheckedIds = Array.from(checkedControlSet);
        var oldCurrentTreeKey = this.currentTreeKey;
        this.currentTreeKey = "";
        this.$nextTick(function () {
            _this.currentTreeKey = oldCurrentTreeKey;
        });
    };
    ModulePermission.prototype.emitClose = function () {
        this.refreshDate();
    };
    ModulePermission.prototype.getAllTreeData = function () {
        var option = {
            keyName: 'id',
            parentKeyName: 'parent',
            sortKey: 'resoSort'
        };
        return CommonService.generateTreeData(this.systemMenus, option);
    };
    ModulePermission.prototype.getRoleTreeData = function (data) {
        var option = {
            keyName: 'id',
            parentKeyName: 'parent',
            sortKey: 'resoSort'
        };
        return this.$common.generateTreeData(data, option);
    };
    ModulePermission.prototype.refreshDate = function () {
        var _this = this;
        if (!this.roleId)
            return;
        // 全部菜单数据
        this.treeData = this.getAllTreeData();
        this.roleService.getSelfResources(this.roleId).subscribe(function (data) {
            _this.checkedMenuIds = data.filter(function (x) { return x.type !== 'CONTROL'; }).map(function (x) { return x.id; });
            _this.controlCheckedIds = data.filter(function (x) { return x.type === 'CONTROL'; }).map(function (x) { return x.id; });
            // 用户权限菜单数据
            var tree = _this.getRoleTreeData(data);
            // 当菜单的子级没有全部选择时，去掉父级的ID，避免选中父级
            tree.forEach(function (v) {
                var obj = _this.treeData.find(function (i) { return i.id === v.id; });
                if (!!obj && obj.children.length !== v.children.length) {
                    var index = _this.checkedMenuIds.findIndex(function (c) { return c === v.id; });
                    _this.checkedMenuIds.splice(index, 1);
                }
            });
        });
    };
    ModulePermission.prototype.onCheckTreeNodeChange = function () {
        if (this.checkedMenuIds.includes(this.currentTreeKey))
            return;
        this.checkedMenuIds.push(this.currentTreeKey);
    };
    ModulePermission.prototype.saveModule = function () {
        var _this = this;
        var treeresource = this.$refs['resource-tree'];
        var checkedResults = __spreadArrays(treeresource.getCheckedNodes(), this.controlCheckedIds);
        this.roleService.roleAttachResource(this.roleId, checkedResults).subscribe(function (data) {
            _this.$message.success("操作成功!");
            _this.emitClose();
        });
    };
    __decorate([
        Dependencies(RoleService)
    ], ModulePermission.prototype, "roleService", void 0);
    __decorate([
        systemModule.Getter
    ], ModulePermission.prototype, "systemControls", void 0);
    __decorate([
        systemModule.Getter
    ], ModulePermission.prototype, "systemMenus", void 0);
    __decorate([
        Prop({ required: true })
    ], ModulePermission.prototype, "roleId", void 0);
    __decorate([
        Emit("refreshList")
    ], ModulePermission.prototype, "refreshList", null);
    __decorate([
        Watch('roleId', { immediate: true })
    ], ModulePermission.prototype, "onRoleIdChange", null);
    __decorate([
        Watch('checkedMenuIds')
    ], ModulePermission.prototype, "onCheckedMenuIdsChange", null);
    __decorate([
        Emit('close')
    ], ModulePermission.prototype, "emitClose", null);
    ModulePermission = __decorate([
        Component({
            components: {
                ResourceTree: ResourceTree,
                ResourceControl: ResourceControl,
                CommonTitle: CommonTitle
            }
        })
    ], ModulePermission);
    return ModulePermission;
}(Vue));
export default ModulePermission;
